import React, { useState, useEffect } from 'react';
import { Heading, Table, Text, Thead, Tbody, Tr, Th, Td, TableContainer } from "@chakra-ui/react";
import './TablePerTag.css';

const TablePerTag = ({ data, tableNumber, tableSize, last, removeItem }) => {
    const [backgroundColor, setBackgroundColor] = useState('transparent');

    let tableData;
    if (last) {
        const startIndex = (tableNumber - 1) * tableSize;
        tableData = data.slice(startIndex);
    } else {
        const startIndex = (tableNumber - 1) * tableSize;
        const endIndex = tableNumber * tableSize;
        tableData = data.slice(startIndex, endIndex);
    }

    useEffect(() => {
        // Change the background to green when new data arrives

        //item.hasOwnProperty("error") ? 'rgba(255, 0, 0, 0.5)' : 
        tableNumber === 1 && setBackgroundColor('green');

        /* // Set a timer to change it back to transparent after 1 second
                const timer = setTimeout(() => {
                    setBackgroundColor('transparent');
                }, 1000); 

        return () => clearTimeout(timer);*/
        // eslint-disable-next-line
    }, [data]); // Depend on 'data' so this effect runs every time 'data' changes

    const getBackgroundColor = (item, index) => {
        // Check if the 'error' property exists and is set
        if (item.hasOwnProperty("error") && item.error) {
            return 'rgba(255, 0, 0, 0.5)'; // Red with 50% transparency
        }
        // Highlight the new row if it's the first row and no error
        if (index === 0 && tableNumber === 1) {
            return 'rgba(166, 242, 141, 0.5)'; // Green for new row
        }
        return 'transparent'; // Default background for other rows
    };


    return (
        <TableContainer className="tableContainer" style={{ maxHeight: last ? '100%' : 'auto', overflowY: last ? 'auto' : 'hidden' }}>
            <Table variant='simple'>
                <Thead>
                    <Tr>
                        <Th><Heading size='md'>SKU</Heading></Th>
                        <Th><Heading size='md'># Serial</Heading></Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {tableData.length > 0 && tableData.map((item, index) => (
                        <Tr key={index} className="transition-background my-element.transparent"
                            onClick={() => { if (item.hasOwnProperty("error") && item.error) removeItem(index) }}
                            style={{ backgroundColor: item.hasOwnProperty("error") ? getBackgroundColor(item, index) : index === 0 && backgroundColor }}>
                            <Td><Text fontSize='2xl'>{item.sku}</Text></Td>
                            <Td><Text fontSize='2xl'>{item.serialNumber}</Text></Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    );
}

export default TablePerTag;
